import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import AppButton from "../ui/AppButton";

// Generic confirmation dialog (any action, not just deletes) - e.g. "Are you
// sure you want to close this sprint?", "Send this invite?", etc.
function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = "Confirm",
  message,
  itemName,
  note,
  extra,
  isLoading = false,
  confirmLabel = "Confirm",
  loadingLabel = "Working...",
  cancelLabel = "Cancel",
  confirmColor = "primary",
  confirmIcon
}) {
  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onClose}
      disableEscapeKeyDown={isLoading}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>

      <DialogContent>
        {message && (
          <DialogContentText>
            {message}
            {itemName && (
              <>
                <br />
                <br />
                <strong>{itemName}</strong>
              </>
            )}
            {note && (
              <>
                <br />
                {note}
              </>
            )}
          </DialogContentText>
        )}

        {extra}
      </DialogContent>

      <DialogActions>
        <AppButton variant="outlined" onClick={onClose} disabled={isLoading}>
          {cancelLabel}
        </AppButton>

        <AppButton
          variant="contained"
          color={confirmColor}
          startIcon={confirmIcon}
          loading={isLoading}
          onClick={onConfirm}
        >
          {isLoading ? loadingLabel : confirmLabel}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;
